var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-empty"},[_c('c-svg-icons',{staticClass:"c-empty-svg",attrs:{"name":"icon_empty"}}),_c('span',{staticClass:"c-empty-span mt-7"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }